import { Article } from './Article';
import { Edition } from './Edition';

export {
    Article,
    Edition
}


// WEBPACK FOOTER //
// ./src/Models/ModelIndex.js